import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFoldDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.75 6C2.75 5.58579 3.08579 5.25 3.5 5.25H4.5C4.91421 5.25 5.25 5.58579 5.25 6C5.25 6.41421 4.91421 6.75 4.5 6.75H3.5C3.08579 6.75 2.75 6.41421 2.75 6Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 5.25C11.0858 5.25 10.75 5.58579 10.75 6C10.75 6.41421 11.0858 6.75 11.5 6.75H12.5C12.9142 6.75 13.25 6.41421 13.25 6C13.25 5.58579 12.9142 5.25 12.5 5.25H11.5Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 9.75V16.4393L9.28033 14.4697C8.98744 14.1768 8.51256 14.1768 8.21967 14.4697C7.92678 14.7626 7.92678 15.2374 8.21967 15.5303L11.4697 18.7803C11.6103 18.921 11.8011 19 12 19C12.1989 19 12.3897 18.921 12.5303 18.7803L15.7803 15.5303C16.0732 15.2374 16.0732 14.7626 15.7803 14.4697C15.4874 14.1768 15.0126 14.1768 14.7197 14.4697L12.75 16.4393V9.75C12.75 9.33579 12.4142 9 12 9C11.5858 9 11.25 9.33579 11.25 9.75Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 5.25C15.0858 5.25 14.75 5.58579 14.75 6C14.75 6.41421 15.0858 6.75 15.5 6.75H16.5C16.9142 6.75 17.25 6.41421 17.25 6C17.25 5.58579 16.9142 5.25 16.5 5.25H15.5Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.75 6C6.75 5.58579 7.08579 5.25 7.5 5.25H8.5C8.91421 5.25 9.25 5.58579 9.25 6C9.25 6.41421 8.91421 6.75 8.5 6.75H7.5C7.08579 6.75 6.75 6.41421 6.75 6Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5 5.25C19.0858 5.25 18.75 5.58579 18.75 6C18.75 6.41421 19.0858 6.75 19.5 6.75H20.5C20.9142 6.75 21.25 6.41421 21.25 6C21.25 5.58579 20.9142 5.25 20.5 5.25H19.5Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgFoldDown;
